{
  "addButtonLabel": "Tukanga rānei, pokanga rānei",
  "date": "Rā",
  "datePlaceholder": "e.g. June 2022, 2021, or ~5 years ago",
  "location": "Wāhi",
  "locationPlaceholder": "e.g. Ormiston Hospital, Auckland",
  "nextLabel": "$t(common:next): <b>Nekehanga</b>",
  "procedure": "Whakamārama mō te pokanga, tukanga rānei",
  "procedurePlaceholder": "Tāuruhia ki te reo Pākehā. Hei tauira: <br/>\nColonoscopy to investigate bleeding",
  "saveButton": "Tiaki pokanga",
  "text": "<p>Kei a mātou te pūkete o tāu pokanga ūwhatu o mua i te {{company}}:</p>\n<ul><li><strong>{{procedure}}</strong> i <strong>{{date}}</strong></li></ul>\n<p>Kua whiwhi kē koe i tētahi atu pokanga ūwhatu, pokanga puku, pokanga nui rānei i muri mai i tērā?</p>",
  "textNoProcedure": "Kua whiwhi kē koe i tētahi pokanga ūwhatu, pokanga puku, pokanga nui rānei i mua?",
  "title": "Ngā pokanga, ngā tukanga tata nei"
}
